import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const ManagePurchaseOrders = Loadable({
  loader: () => import('./Containers/manage-purchase-orders'),
  loading: Loading
});

const PurchaseOrderDetail = Loadable({
  loader: () => import('./Containers/purchase-order-detail'),
  loading: Loading
});

export default [
  {
    path: '/purchase-orders',
    component: ManagePurchaseOrders,
    private: true,
    menu: {
      name: 'Purchase orders',
      order: 8,
      icons: 'icon-purchase-orders-ic'
    },
    portal: ['Subcontractor']
  },
  {
    path: '/purchase-orders/:WOID/:POID',
    component: PurchaseOrderDetail,
    private: true,
    portal: ['Subcontractor']
  }
];



// WEBPACK FOOTER //
// ./src/Purchase-Orders/routers.js